import React from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import { helpers } from "@shared";
import { BeginEnrollament } from ".";

const StepBeginEnrollament = () => {

    const navigate = useNavigate(), location = useLocation();
    const { state: { invoice } } = location;

    const next = () => {
        helpers.navigateNext(location, navigate);
    };

    //TODO code removed, needs revisit
    const alerts = [];

    return (
        <BeginEnrollament next={next} invoice={invoice} alerts={alerts} />
    );
};

export default StepBeginEnrollament;
